// NOT IN USE - Managed in a different way now
// Kept for reference

import { Divider } from 'antd'
import { Switch } from '@/components/ui'
import { PlusCircleFilled, EllipsisOutlined } from '@ant-design/icons'
import { Drawer, Button } from '@/components/ui'
import { Icon } from '@/components/icons'
import type { RegistrationField } from '../types'

interface ManageFieldsDrawerProps {
  open: boolean
  onClose: () => void
  fields: RegistrationField[]
  onAddNew: () => void
  onToggleVisibility: (field: RegistrationField, shown: boolean) => void
}

export default function ManageFieldsDrawer({
  open,
  onClose,
  fields,
  onAddNew,
  onToggleVisibility
}: ManageFieldsDrawerProps) {
  // Separate default and custom fields
  const defaultFields = fields.filter((f) => f.is_default)
  const customFields = fields.filter((f) => !f.is_default)

  const handleToggle = (field: RegistrationField, checked: boolean) => {
    onToggleVisibility(field, checked)
  }

  const renderFieldRow = (field: RegistrationField) => (
    <div
      key={field.id}
      className="flex items-center justify-between py-3 px-2 hover:bg-gray-50 rounded"
    >
      <div className="flex items-center gap-3 flex-1">
        <Icon name="dragHandle" size={20} className="text-gray-400 cursor-move" />
        <span className="text-sm text-gray-700">{field.label}</span>
      </div>
      <div className="flex items-center gap-2">
        <Switch
          checked={field.shown_on_form}
          disabled={field.identifier === 'email'}
          onChange={(checked) => handleToggle(field, checked)}
          size="small"
        />
        <EllipsisOutlined className="text-gray-400 cursor-pointer" />
      </div>
    </div>
  )

  return (
    <Drawer
      title="Form Fields"
      onClose={onClose}
      open={open}
      onSubmit={onClose}
      submitText="Add"
    >
      <div className="mb-4 text-sm text-gray-500">
        You may select from a default form field list or create custom fields.
      </div>

      {/* Header Row */}
      <div className="flex items-center justify-between py-2 px-2 border-b border-gray-200 mb-2">
        <span className="text-sm font-medium text-gray-700">Field</span>
        <span className="text-sm font-medium text-gray-700">Apply to this form</span>
      </div>

      {/* Default Fields */}
      <div className="space-y-1">
        {defaultFields.map(renderFieldRow)}
      </div>

      {/* Custom Fields (if any) */}
      {customFields.length > 0 && (
        <>
          <Divider className="my-4" />
          <div className="text-xs font-medium text-gray-500 mb-2">CUSTOM FIELDS</div>
          <div className="space-y-1">
            {customFields.map(renderFieldRow)}
          </div>
        </>
      )}

      {/* Add New Field Button */}
      <Button
        variant="text"
        icon={<PlusCircleFilled />}
        onClick={onAddNew}
        className="mt-4 w-full"
        block
      >
        Add New Field
      </Button>
    </Drawer>
  )
}
